import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

const Home: React.FC = () => {
  // @ts-ignore
  const { t } = useTranslation();

  return (
    <>
      <div className="hero-section">
        {/* @ts-ignore */}
        <h1>{t('home.hero.title')}</h1>
        {/* @ts-ignore */}
        <p className="subtitle">{t('home.hero.subtitle')}</p>
        {/* @ts-ignore */}
        <p className="description">{t('home.hero.description')}</p>
        <div className="cta-buttons">
          {/* @ts-ignore */}
          <Link to="/services" className="primary-button">{t('common.getStarted')}</Link>
          {/* @ts-ignore */}
          <Link to="/about" className="secondary-button">{t('common.learnMore')}</Link>
        </div>
      </div>

      <div className="features-section">
        {/* @ts-ignore */}
        <h2>{t('home.features.title')}</h2>
        <div className="features-grid">
          <div className="feature-card">
            <div className="feature-icon">🚀</div>
            {/* @ts-ignore */}
            <h3>{t('home.features.feature1')}</h3>
            {/* @ts-ignore */}
            <p>{t('home.features.feature1_desc')}</p>
          </div>
          <div className="feature-card">
            <div className="feature-icon">👨‍💻</div>
            {/* @ts-ignore */}
            <h3>{t('home.features.feature2')}</h3>
            {/* @ts-ignore */}
            <p>{t('home.features.feature2_desc')}</p>
          </div>
          <div className="feature-card">
            <div className="feature-icon">🔧</div>
            {/* @ts-ignore */}
            <h3>{t('home.features.feature3')}</h3>
            {/* @ts-ignore */}
            <p>{t('home.features.feature3_desc')}</p>
          </div>
        </div>
      </div>
    </>
  );
};

export default Home; 